module.exports = __webpack_public_path__ + "img/ary.756c6ac5.jpg";